import { forwardRef } from 'react';
import { CardLayout } from '../../lib/card';
import { usePost } from '../Post';
import {
  CardActionsBlock,
  CardContainer,
  CardMediaBlock,
  CardPreviewLinkBlock,
  CardRepostPreviewBlock,
  CardTextBlock,
  CardUserBlock
} from '../parts';
import { usePostAction, usePostSettings } from '../utils';

interface Card4Props {
  space: number;
}

export const Card4 = forwardRef<HTMLDivElement, Card4Props>(
  ({ space, ...forwardingProps }, forwardingRef) => {
    const { horizontal, showMedia, showTextLink } = usePost();
    const { backgroundColor, borderRadius, showShadow, shadow } =
      usePostSettings();
    const handleAction = usePostAction();

    return (
      <CardContainer
        {...forwardingProps}
        ref={forwardingRef}
        onClick={handleAction}
        _space={space}
        _backgroundColor={backgroundColor}
        _borderRadius={borderRadius}
        _shadow={showShadow ? shadow : undefined}
      >
        {horizontal ? (
          <CardLayout.Columns>
            <CardLayout.HorizontalCardContentContainer>
              <CardTextBlock grow />
              <CardRepostPreviewBlock ratio={0.66} />
              {showTextLink && <CardPreviewLinkBlock />}
              <CardUserBlock withSource />
              <CardActionsBlock withTopDivider />
            </CardLayout.HorizontalCardContentContainer>

            {showMedia && <CardMediaBlock thumbnail ratio={0.66} />}
          </CardLayout.Columns>
        ) : (
          <>
            {showMedia && <CardMediaBlock thumbnail ratio={0.66} />}

            <CardTextBlock />
            <CardRepostPreviewBlock ratio={0.66} />
            {showTextLink && <CardPreviewLinkBlock />}
            <CardUserBlock withSource />
            <CardActionsBlock withTopDivider />
          </>
        )}
      </CardContainer>
    );
  }
);

Card4.displayName = 'Card4';
